import { ColumnInfoCollectionInterface, ColumnInfoInterface, ExtColumnInfoInterface } from '@nts/std/interfaces';

export class ColumnInfoCollection extends Array<ColumnInfoInterface | ExtColumnInfoInterface> implements ColumnInfoCollectionInterface {

  metadataDescription: string;
  metadataShortDescription: string;
  editableDefinition = null;

}
